const forgotPasswordUser = ''
const forgotPasswordMessage = ''
const forgotPasswordError = ''

export default {
    forgotPasswordUser,
    forgotPasswordMessage,
    forgotPasswordError,
}